// extracted by mini-css-extract-plugin
module.exports = {"box":"TextStackHero--box--2f6O2","max_width":"TextStackHero--max_width--3jDDr","max_width_sub":"TextStackHero--max_width_sub--17dt4"};